module.exports = __webpack_public_path__ + "img/video_placeholder_story.44b753bb.jpg";